export interface NetState {
  offline: boolean;
  // requests that would have left the browser since the toggle; the wrapper and the
  // service worker both refuse them and count them here
  blocked: number;
}

const KEY = 'offline';

let state: NetState = { offline: readFlag(), blocked: 0 };
const listeners = new Set<() => void>();

function readFlag(): boolean {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

function emit(next: NetState) {
  state = next;
  for (const l of listeners) l();
}

export function netState(): NetState {
  return state;
}

export function subscribeNet(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setOffline(offline: boolean) {
  try {
    if (offline) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // private mode: the toggle still works until the next reload
  }
  emit({ offline, blocked: 0 });
  tellServiceWorker(offline);
}

export async function net(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (!state.offline) return fetch(input, init);
  const request = new Request(input, init);
  const hit =
    typeof caches === 'undefined'
      ? undefined
      : await caches.match(request, { ignoreMethod: request.method === 'HEAD' });
  if (hit) return hit;
  emit({ ...state, blocked: state.blocked + 1 });
  throw new TypeError(`offline: ${request.url}`);
}

function tellServiceWorker(offline: boolean) {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
  void navigator.serviceWorker.ready.then((r) =>
    r.active?.postMessage({ type: 'offline', offline }),
  );
}

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('message', (e: MessageEvent<{ type?: string }>) => {
    if (e.data?.type === 'blocked' && state.offline) emit({ ...state, blocked: state.blocked + 1 });
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => tellServiceWorker(state.offline))
      .catch((err) => console.warn('[sw] registration failed', err));
  });
}
